import { FEATURES, PRODUCT_FAMILY, PRODUCTS } from '@/base/constants/authorization'

export const appAnalysisAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.MARKET } },
    {
      $or: [
        { name: { $eq: PRODUCTS.MARKET_ENTERPRISE } },
        { name: { $eq: PRODUCTS.MARKET_PRO } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_MARKET_INTELLIGENCE },
        },
      },
    },
  ],
}
export const storeAnalysisAccessRule = appAnalysisAccessRule
export const publisherAnalysisAccessRule = appAnalysisAccessRule
export const topAppsAccessRule = appAnalysisAccessRule
export const topPublishersAccessRule = appAnalysisAccessRule
